import { useState } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import BrivoClearUsersComponent from './BrivoClearUsersComponent';

import { clearBrivoUsers, getBrivoCleanupUsers } from './actions';

import * as selectors from './selectors';

const LIST_KEY = 'brivoCleanupUsers';

const BrivoClearUsersContainer = (props) => {
  const {
    match,
    listParams,
    brivoCleanupUsers,
    getBrivoCleanupUsers,
    clearBrivoUsers,
  } = props;
  const brivoAccountId = match?.params?.id;

  const [selectedUsers, setSelectedUsers] = useState([]);

  const getItems = (queryParams) =>
    getBrivoCleanupUsers(brivoAccountId, queryParams);

  const onSelectUser = (user) => {
    const isSelected = !!selectedUsers.find(({ id }) => id === user.id);
    if (isSelected) {
      const filteredUsers = [...selectedUsers].filter(
        ({ id }) => id !== user.id,
      );
      return setSelectedUsers(filteredUsers);
    }
    const updatedUsers = [...selectedUsers, user];
    return setSelectedUsers(updatedUsers);
  };

  const onClearBrivoUsers = async () => {
    const data = {
      persons: [
        ...selectedUsers.map(({ id, externalId, person }) => ({
          id,
          externalId,
          person,
        })),
      ],
    };
    const isRemoved = await clearBrivoUsers(brivoAccountId, data);
    if (isRemoved) {
      getItems(listParams);
      setSelectedUsers([]);
    }
  };

  const items = {
    ...brivoCleanupUsers,
    results: brivoCleanupUsers?.results?.map((user) => {
      const isSelected = !!selectedUsers.find(({ id }) => id === user.id);
      return { ...user, isSelected };
    }),
  };

  return (
    <BrivoClearUsersComponent
      {...props}
      items={items}
      selectedUsers={selectedUsers}
      getItems={getItems}
      onSelectUser={onSelectUser}
      onClearBrivoUsers={onClearBrivoUsers}
    />
  );
};

BrivoClearUsersContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  brivoCleanupUsers: PropTypes.instanceOf(Object).isRequired,
  listParams: PropTypes.instanceOf(Object).isRequired,
  getBrivoCleanupUsers: PropTypes.func.isRequired,
  clearBrivoUsers: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  isLoading: selectors.getIsLoading(state),
  brivoCleanupUsers: selectors.getBrivoCleanupUsers(state),
  listParams: selectors.getListParams(state, LIST_KEY),
  listKey: LIST_KEY,
});

const mapDispatchToProps = (dispatch) => ({
  onLoad: () => {},
  getBrivoCleanupUsers: (accountId, queryParams) =>
    getBrivoCleanupUsers(dispatch, accountId, queryParams),
  clearBrivoUsers: (accountId, data) =>
    clearBrivoUsers(dispatch, accountId, data),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BrivoClearUsersContainer);
